import React from 'react';
import { LogoBrand } from '../components/Logo';
import { LanguageSelector } from '../components/LanguageSelector';
import { useLang } from '../App';
import { HardHat } from 'lucide-react';

const TEXT = {
  en: {
    badge: 'Under construction',
    title: 'Platform under construction',
    body: 'The IDFC Global Cofinancing Engine is currently in development. Access will open soon to the 27 member institutions.',
    foot: '27 Members · UN SDGs · Paris Agreement',
  },
  fr: {
    badge: 'En construction',
    title: 'Plateforme en cours de construction',
    body: "Le Global Cofinancing Engine de l'IDFC est en cours de développement. L'accès sera ouvert prochainement aux 27 institutions membres.",
    foot: "27 Membres · ODD de l'ONU · Accord de Paris",
  },
  es: {
    badge: 'En construcción',
    title: 'Plataforma en construcción',
    body: 'El Global Cofinancing Engine del IDFC está en desarrollo. El acceso se abrirá próximamente a las 27 instituciones miembros.',
    foot: '27 Miembros · ODS de la ONU · Acuerdo de París',
  },
  pt: {
    badge: 'Em construção',
    title: 'Plataforma em construção',
    body: 'O Global Cofinancing Engine do IDFC está em desenvolvimento. O acesso será aberto em breve às 27 instituições membros.',
    foot: '27 Membros · ODS da ONU · Acordo de Paris',
  },
  ja: {
    badge: '構築中',
    title: 'プラットフォームは構築中です',
    body: 'IDFC Global Cofinancing Engine は現在開発中です。まもなく27の加盟機関にアクセスが開放されます。',
    foot: '27の加盟機関 · 国連SDGs · パリ協定',
  },
};

const MaintenancePage = () => {
  const { lang } = useLang();
  const t = TEXT[lang] || TEXT.en;

  return (
    <div className="min-h-screen w-full flex flex-col items-center justify-center px-6 relative overflow-hidden" style={{ background: '#112C38' }} data-testid="maintenance-page">
      <div className="absolute inset-0 opacity-[0.06]" style={{ backgroundImage: 'radial-gradient(circle at 20% 30%, #45B08F 0, transparent 40%), radial-gradient(circle at 80% 70%, #F5C544 0, transparent 45%)' }} />
      <div className="absolute top-5 right-6 z-10">
        <LanguageSelector tone="light" testId="maintenance-lang-selector" />
      </div>

      <div className="relative z-10 max-w-xl w-full text-center">
        <div className="flex justify-center mb-10">
          <LogoBrand size={44} />
        </div>

        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-[#F5C544]/40 bg-[#F5C544]/10 mb-8">
          <HardHat className="w-4 h-4 text-[#F5C544]" />
          <span className="text-[11px] uppercase tracking-[0.25em] text-[#F5C544] font-medium">{t.badge}</span>
        </div>

        <h1 className="text-3xl sm:text-4xl font-semibold text-white leading-tight mb-5" data-testid="maintenance-title">
          {t.title}
        </h1>
        <p className="text-base text-slate-300 leading-relaxed" data-testid="maintenance-body">
          {t.body}
        </p>

        <div className="mt-12 h-px w-24 mx-auto bg-gradient-to-r from-transparent via-[#45B08F] to-transparent" />
        <p className="mt-6 text-[10px] uppercase tracking-[0.3em] text-slate-500">{t.foot}</p>
      </div>
    </div>
  );
};

export default MaintenancePage;
